/**
 * Image Text Block - Swiper + Before/After initialization
 * Loaded conditionally when slider or before/after is enabled
 */

if (!customElements.get('image-text-block')) {
  class ImageTextBlock extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSwiper();
      this.initBeforeAfter();
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initSwiper() {
      const swiperEl = this.querySelector('.image-text-block__swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: swiperEl.querySelector('.image-text-block__swiper-pagination'),
          clickable: true
        },
        navigation: {
          prevEl: swiperEl.querySelector('.image-text-block__swiper-arrow--prev'),
          nextEl: swiperEl.querySelector('.image-text-block__swiper-arrow--next')
        }
      });
    }

    initBeforeAfter() {
      const containers = this.querySelectorAll('[data-before-after]');
      if (!containers.length) return;

      containers.forEach((container) => this.setupSlider(container));
    }

    setupSlider(container) {
      const handle = container.querySelector('[data-ba-handle]');
      const line = container.querySelector('[data-ba-line]');
      const beforeEl = container.querySelector('[data-ba-before]');
      const afterEl = container.querySelector('[data-ba-after]');

      if (!handle || !line || !beforeEl || !afterEl) return;

      let isDragging = false;
      let position = 50;

      const updatePosition = (percentage) => {
        position = Math.max(0, Math.min(100, percentage));
        const pos = position + '%';

        handle.style.left = pos;
        line.style.left = pos;
        beforeEl.style.clipPath = 'polygon(0% 0%, ' + pos + ' 0%, ' + pos + ' 100%, 0% 100%)';
        afterEl.style.clipPath = 'polygon(' + pos + ' 0%, 100% 0%, 100% 100%, ' + pos + ' 100%)';
      };

      const getPercentage = (e) => {
        const rect = container.getBoundingClientRect();
        if (rect.width === 0) return position;
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        return ((clientX - rect.left) / rect.width) * 100;
      };

      const onMove = (e) => {
        if (!isDragging) return;
        updatePosition(getPercentage(e));
        e.preventDefault();
      };

      const onEnd = () => {
        isDragging = false;
      };

      container.addEventListener('mousedown', (e) => {
        isDragging = true;
        updatePosition(getPercentage(e));
        e.preventDefault();
      });

      container.addEventListener('touchstart', (e) => {
        isDragging = true;
        updatePosition(getPercentage(e));
        e.preventDefault();
      }, { passive: false });

      document.addEventListener('mousemove', onMove);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('mouseup', onEnd);
      document.addEventListener('touchend', onEnd);

      updatePosition(50);
    }
  }

  customElements.define('image-text-block', ImageTextBlock);
}
